var map = {
  "./cs.messages.tsx": [
    "45858",
    [
      64367
    ]
  ],
  "./en.messages.tsx": [
    "22027",
    [
      79188
    ]
  ],
  "./sl.messages.tsx": [
    "42827",
    [
      82620
    ]
  ],
  "./hu.messages.tsx": [
    "72543",
    [
      72468
    ]
  ],
  "./de.messages.tsx": [
    "40467",
    [
      26704
    ]
  ],
  "./it.messages.tsx": [
    "69837",
    [
      28286
    ]
  ],
  "./pl.messages.tsx": [
    "99588",
    [
      56573
    ]
  ],
  "./fr.messages.tsx": [
    "44556",
    [
      32405
    ]
  ],
  "./sk.messages.tsx": [
    "48330",
    [
      69047
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 50944;
module.exports = __rspack_async_context;
